import exTable from './exTable'
import exTableCol from './exTableCol'

export const exTableComponent = {
  install:function(Vue){
    Vue.component(exTable.name,exTable);
  }
} 
export const exTableColComponent = {
  install:function(Vue){
    Vue.component(exTableCol.name,exTableCol);
  }
} 


// WEBPACK FOOTER //
// ./src/components/table/index.js